<template>
  <ThreeDLayerDropdown
    v-analytics="'modelViewerLayerButtonSelected'"
    :is-layer-menu-showing="expanded"
    @toggle="$emit('update:expanded', !expanded)"
  >
    <DeckDeprecatedGroupedLayers
      class="w-96 pl-6 pr-4"
      :layer-groups="layerGroups"
      @set-layer-visible="$emit('set-layer-visible', $event)"
    />
  </ThreeDLayerDropdown>
</template>

<script lang="ts" setup>
import type { LayerGroup } from '@/composables/useThreeDViewer'

defineProps({
  layerGroups: {
    type: Array as PropType<LayerGroup[]>,
    required: true,
  },
  expanded: {
    type: Boolean,
    required: true,
  },
})

defineEmits(['update:expanded', 'set-layer-visible'])
</script>

<style lang="stylus" scoped>
.three-d-dropdown
  :deep(.dropdown-item)
    padding-top 1rem
    padding-left 1.875rem
    padding-right 1.875rem
    padding-bottom 0

    &:first-of-type
      padding-top 1.25rem

  :deep(.three-d-dropdown-list)
    --arrowRight auto
    --arrowLeft 50%
    right 50%
    transform translateX(50%)

  @screen md
    :deep(.three-d-dropdown-list)
      --arrowRight 1.75rem
      --arrowLeft auto
      right -1rem
      transform none
</style>
